<template>
  <div class="atom-text-area__container w-100">
    <div v-if="title" class="atom-text-area__title">
      {{ title
      }}<label v-if="isAsterisk" class="atom-text-area__asterisk">*</label>
    </div>
    <b-form-textarea
      v-model="inputValue"
      :state="isErrorOccur"
      :disabled="isDisable"
      :placeholder="placeholder"
      :no-resize="!isResizable"
      :rows="rows"
    ></b-form-textarea>
    <div v-if="isError" class="atom-text-area__error">{{ errorMessage }}</div>
  </div>
</template>

<script>
import { BFormTextarea } from "bootstrap-vue"
export default {
  name: "AtomTextArea",
  components: { BFormTextarea },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    isError: {
      type: Boolean,
      required: false,
      default: null,
    },
    errorMessage: {
      type: String,
      required: false,
      default: "",
    },
    isAsterisk: {
      type: Boolean,
      required: false,
      default: false,
    },
    isResizable: {
      type: Boolean,
      required: false,
      default: false,
    },
    rows: { // height in unit row
      type: Number,
      required: false,
      default: 5,
    },
    value: {
      type: [String, Number],
      required: false,
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    isErrorOccur() {
      return this.isError ? false : null
    },
  },
}
</script>

<style lang="scss" scoped>
.atom-text-area__title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}

.atom-text-area__asterisk {
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 0;
}

.atom-text-area__error {
  color: #ea5455;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.5;
}
</style>
